module.exports = __webpack_public_path__ + "static/media/grades-cal.ea2c1237.png";